import { render, staticRenderFns } from "./OnboardingStepFollowUpSequences.vue?vue&type=template&id=dcef40e6&scoped=true&"
import script from "./OnboardingStepFollowUpSequences.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepFollowUpSequences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcef40e6",
  null
  
)

export default component.exports